import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

/**
 * Интерсептор для отключения кеширования запросов в IE.
 */
@Injectable()
export class DisableIeCachingHttpInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isIe = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIe && req.method === 'GET') {
      req = req.clone(
        {
          headers: req.headers
            .set('Expires', '-1')
            .set('Pragma', 'no-cache')
            .set('Cache-Control', 'no-cache, must-revalidate, no-store')
        });
    }
    return next.handle(req);
  }
}
